import { render, staticRenderFns } from "./QuestionsCard.vue?vue&type=template&id=e52d451a"
import script from "./QuestionsCard.vue?vue&type=script&lang=js"
export * from "./QuestionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports